import React, { useState, useRef, useEffect, useCallback } from 'react'
import { ChromePicker as ColorPicker } from 'react-color'

import Textfield from '@react/react-spectrum/Textfield'

import './ColorInput.scss'

export default ({ placeholder, name, value, defaultValue, disabled, onChange, required }) => {
  const [showColorPicker, setShowColorPicker] = useState(false)
  const [color, setColor] = useState(value || defaultValue)

  const colorPickerElement = useRef(null)

  useEffect(() => {
    // add event listener to handle clicking outside of the color picker
    document.addEventListener('mousedown', clickListener)

    return () => {
      document.removeEventListener('mousedown', clickListener)
    }
  }, [])

  useEffect(() => {
    setColor(value)
  }, [value])

  const clickListener = useCallback(
    (e) => {
      // if user clicked outside, hide the color picker
      if (colorPickerElement.current && !colorPickerElement.current.contains(e.target)) {
        setShowColorPicker(false)
      }
    },
    [colorPickerElement]
  )

  const _onChange = (value) => {
    const newColor = value.hex || value
    setColor(newColor)
    onChange(newColor)
  }

  return (
    <div className='color-input-wrapper'>
      <div
        className='color-input-indicator'
        style={{ backgroundColor: color }}
        onClick={() => setShowColorPicker(!showColorPicker)}
      ></div>
      <Textfield
        placeholder={placeholder}
        name={name}
        value={color}
        onChange={_onChange}
        disabled={disabled}
        required={required}
      />

      {showColorPicker && !disabled && (
        <div ref={colorPickerElement} className='color-picker'>
          <ColorPicker color={color} onChange={_onChange} />
        </div>
      )}
    </div>
  )
}
